import React from 'react';
import {Card,Col,Row,} from 'react-bootstrap';

const StepAway = (props) => {
    
    return (
       
        <Card className='mb-3'> 
            <Card.Body>
                <h3>Need to step away?</h3>
                <p>Your progress has been saved. If you need to step away, copy the link below and save it to finish your application later.</p>
                <Row>
                    <Col xl={2} lg={4} sm={3} md={2}>
                        <button onClick={()=>props.handleCopy()} className="btn btn-primary btn-block">COPY LINK</button>
                    </Col>
                    <Col xl={10} lg={8} sm={9} md={10} >
                        <input type="text" className="form-control" defaultValue={props.copyInputValue} id="myInput" disabled
                        />
                    </Col>
                </Row>
            </Card.Body>
        </Card>
     
    ); 
}

export default StepAway;